import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));
const useStyles = makeStyles({
  root: {
    "& .MuiButtonBase-root": {
      padding: "0",
      color: "white",
    },
  },
});
export default function Dropdown() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="text"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        MORE
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} disableRipple>
          Furnishings / Sanitaryware / Electricals
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Retail
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Architecture / Interior Design
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Export-Import / Trading
        </MenuItem>

        <MenuItem onClick={handleClose} disableRipple>
          Industrial Design
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Media/Entertainment
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Metal/Iron/Steel
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Personal Care/Beauty/Wellness
        </MenuItem>

        <MenuItem onClick={handleClose} disableRipple>
          Pharma & Biotech
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Textile/Garments/Fashion
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Heat Ventilation/Air conditioning
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Automation
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Hospitality
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Heavy machinery
        </MenuItem>
        <MenuItem onClick={handleClose} disableRipple>
          Brewery/beverages
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
